const ls = require('local-storage');

export const AppIsLocked = () => {
    const lockDate = ls('LockDate');

    const isLocked = !!lockDate && new Date(lockDate) <= new Date();

    return isLocked;
};

export const LockDate = () => (ls('LockDate'));

const Lock = props =>
    AppIsLocked()
        ? props.locked()
        : props.unlocked();

Lock.defaultProps = {
    locked: () => null,
    unlocked: () => null
};

export default Lock;


// WEBPACK FOOTER //
// ./src/components/Shared/Lock.js